import { FunctionComponent } from 'react';
import { useIntl } from 'react-intl';
import { BulkStatusMaxSizeErrorMessage } from '../../sharedComponents/bulkStatusUpdate/BulkStatusMaxSizeErrorMessage';

type TransportOrderBulkUpdateMaxSizeErrorMessageProps = {
    readonly totalCount?: number;
    readonly maxBulkSize: number;
};

export const TransportOrderBulkUpdateMaxSizeErrorMessage: FunctionComponent<
    TransportOrderBulkUpdateMaxSizeErrorMessageProps
> = ({ totalCount, maxBulkSize }) => {
    const { formatMessage } = useIntl();

    return (
        <BulkStatusMaxSizeErrorMessage
            maxBulkSizeExceededText={formatMessage({
                id: 'outboundOrderBook.transportAssignments.bulkUpdate.error.maxBulkSizeExceeded',
            })}
            maxSelectionSizeText={formatMessage(
                { id: 'outboundOrderBook.transportAssignments.bulkUpdate.error.maxSelectionSize' },
                { count: maxBulkSize },
            )}
            selectionSizeText={formatMessage({
                id: 'outboundOrderBook.transportAssignments.bulkUpdate.error.selectionSize',
            })}
            totalCount={totalCount}
        />
    );
};
